export const SERVICE_TYPE = Object.freeze({
  LOCAL: 1,
  OUTSTATION: 2,
  PASSENGER: 3,
});

export const PASSENGER_VEHICLE_NAMES = Object.freeze([
  'Mini Segment',
  'Sedan',
  '7 Seater',
]);

export const isLocalStyleService = (serviceType) => {
  const type = Number(serviceType);
  return type === SERVICE_TYPE.LOCAL || type === SERVICE_TYPE.PASSENGER;
};

export const isOutstationService = (serviceType) =>
  Number(serviceType) === SERVICE_TYPE.OUTSTATION;

export const isPassengerService = (serviceType) =>
  Number(serviceType) === SERVICE_TYPE.PASSENGER;

export const getServiceTypeLabel = (serviceType) => {
  const type = Number(serviceType);
  if (type === SERVICE_TYPE.LOCAL) return 'Local';
  if (type === SERVICE_TYPE.OUTSTATION) return 'Outstation';
  if (type === SERVICE_TYPE.PASSENGER) return 'Passenger';
  return 'Unknown';
};

export const isCustomerUser = (user) =>
  Number(user?.user_type ?? user?.usertype) === 2;

export const isPassengerUser = (user) =>
  Number(user?.user_type ?? user?.usertype) === 7;

export const isPassengerVehicle = (vehicle) => {
  if (!vehicle) return false;
  const serviceTypes = String(vehicle.vehicle_service_types || '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
  if (serviceTypes.includes(String(SERVICE_TYPE.PASSENGER))) return true;
  return PASSENGER_VEHICLE_NAMES.includes(vehicle.vehicle_name);
};

export const isLocalVehicle = (vehicle) => {
  if (!vehicle) return false;
  const serviceTypes = String(vehicle.vehicle_service_types || '1')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
  if (serviceTypes.includes(String(SERVICE_TYPE.LOCAL))) return true;
  return !isPassengerVehicle(vehicle);
};

export const filterVehiclesForServiceType = (vehicles, serviceType) => {
  const list = Array.isArray(vehicles) ? vehicles : [];
  if (isPassengerService(serviceType)) {
    return list.filter(isPassengerVehicle);
  }
  if (Number(serviceType) === SERVICE_TYPE.LOCAL) {
    return list.filter(isLocalVehicle);
  }
  return list;
};
